var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartyConfetti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_14802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 30C37.5228 30 42 25.5228 42 20C42 14.4772 37.5228 10 32 10C26.4772 10 22 14.4772 22 20C22 25.5228 26.4772 30 32 30Z",
    fill: "#F9CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 24C84.4183 24 88 20.4183 88 16C88 11.5817 84.4183 8 80 8C75.5817 8 72 11.5817 72 16C72 20.4183 75.5817 24 80 24Z",
    fill: "#F9CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 64C82.4183 64 86 60.4183 86 56C86 51.5817 82.4183 48 78 48C73.5817 48 70 51.5817 70 56C70 60.4183 73.5817 64 78 64Z",
    fill: "#F9CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.932 48.864C69.6568 45.1471 74.7039 43.0596 79.966 43.0596C85.2281 43.0596 90.2752 45.1471 94 48.864",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0719 30.072C48.9158 28.2292 50.3786 26.0411 51.3766 23.6327C52.3746 21.2243 52.8882 18.6429 52.8882 16.036C52.8882 13.4291 52.3746 10.8477 51.3766 8.4393C50.3786 6.03095 48.9158 3.84284 47.0719 2",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3 32.996L86.336 28.324",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.944 23.648L67.624 9.608",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.86 19.084C32.1252 19.084 32.3796 19.1894 32.5671 19.3769C32.7546 19.5644 32.86 19.8188 32.86 20.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.86 20.084C30.86 19.8188 30.9653 19.5644 31.1529 19.3769C31.3404 19.1894 31.5948 19.084 31.86 19.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.86 21.084C31.5948 21.084 31.3404 20.9786 31.1529 20.7911C30.9653 20.6036 30.86 20.3492 30.86 20.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.86 20.084C32.86 20.3492 32.7546 20.6036 32.5671 20.7911C32.3796 20.9786 32.1252 21.084 31.86 21.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86 31.084C62.1252 31.084 62.3796 31.1894 62.5671 31.3769C62.7546 31.5644 62.86 31.8188 62.86 32.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.86 32.084C60.86 31.8188 60.9653 31.5644 61.1529 31.3769C61.3404 31.1894 61.5948 31.084 61.86 31.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86 33.084C61.5948 33.084 61.3404 32.9786 61.1529 32.7911C60.9653 32.6036 60.86 32.3492 60.86 32.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.86 32.084C62.86 32.3492 62.7546 32.6036 62.5671 32.7911C62.3796 32.9786 62.1252 33.084 61.86 33.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.86 55.084C78.1252 55.084 78.3796 55.1893 78.5671 55.3769C78.7546 55.5644 78.86 55.8188 78.86 56.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.86 56.084C76.86 55.8188 76.9653 55.5644 77.1529 55.3769C77.3404 55.1893 77.5948 55.084 77.86 55.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.86 57.084C77.5948 57.084 77.3404 56.9786 77.1529 56.7911C76.9653 56.6036 76.86 56.3492 76.86 56.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.86 56.084C78.86 56.3492 78.7546 56.6036 78.5671 56.7911C78.3796 56.9786 78.1252 57.084 77.86 57.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.86 15.084C80.1252 15.084 80.3796 15.1894 80.5671 15.3769C80.7546 15.5644 80.86 15.8188 80.86 16.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.86 16.084C78.86 15.8188 78.9653 15.5644 79.1529 15.3769C79.3404 15.1894 79.5948 15.084 79.86 15.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.86 17.084C79.5948 17.084 79.3404 16.9786 79.1529 16.7911C78.9653 16.6036 78.86 16.3492 78.86 16.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.86 16.084C80.86 16.3492 80.7546 16.6036 80.5671 16.7911C80.3796 16.9786 80.1252 17.084 79.86 17.084",
    stroke: "#00303E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.58 66.3L9.93602 93.364C8.91557 93.9096 7.74667 94.1125 6.60206 93.9426C5.45744 93.7727 4.39784 93.2392 3.57983 92.4207C2.76182 91.6023 2.22882 90.5424 2.05957 89.3976C1.89033 88.2529 2.09384 87.0841 2.64002 86.064L29.7 35.42L60.58 66.3Z",
    fill: "#FF9E9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1399 50.86L29.6999 35.42L2.63994 86.064C2.09454 87.0856 1.89337 88.256 2.06632 89.4011C2.23928 90.5463 2.77714 91.605 3.59994 92.42L45.1399 50.86Z",
    fill: "#F9CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.58 66.3L9.93602 93.364C8.91557 93.9096 7.74667 94.1125 6.60206 93.9426C5.45744 93.7727 4.39784 93.2392 3.57983 92.4207C2.76182 91.6023 2.22882 90.5424 2.05957 89.3976C1.89033 88.2529 2.09384 87.0841 2.64002 86.064L29.7 35.42",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5625 65.5495C65.4678 61.6442 61.6688 51.5136 53.0773 42.922C44.4857 34.3305 34.3551 30.5315 30.4499 34.4368C26.5446 38.342 30.3436 48.4726 38.9351 57.0642C47.5267 65.6557 57.6573 69.4547 61.5625 65.5495Z",
    fill: "#FF9E9B",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_14802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyConfetti);
export default __webpack_public_path__ + "static/media/Party_Confetti.4096b68b661e80c62ea3c450d43df27c.svg";
export { ForwardRef as ReactComponent };